import { useAuthUser } from "../../../core_stores/useAuthStore";
import { useUserSubscription } from "../../../core_stores/useSubscriptionStore";
import { colors, typography, effects } from "../../../design/tokens";
import { formatTokensCompact } from "../../../utils/numberFormatter";
import { useSideMenuActions } from "../../../view_stores/useSideMenuStore";

const AVATAR_SIZE = 28;

export default function SideMenuProfile(): JSX.Element {
  const user = useAuthUser();
  const subscription = useUserSubscription();
  const { openPersonalSettings } = useSideMenuActions();

  function handleClick(): void {
    openPersonalSettings("plans");
  }

  const planName = subscription?.plan ?? "Dream";
  const tokenCount = formatTokensCompact(subscription?.remaining ?? 0);

  return (
    <button
      className={`w-full py-2 px-2 ${effects.borderRadius.lg}
        ${colors.hover.backgroundAlt} cursor-pointer transition-colors`}
      onClick={handleClick}
    >
      <div className="grid grid-cols-[28px_1fr] items-center gap-3">
        <img
          src={user?.photoURL || ""}
          alt="Profile"
          width={AVATAR_SIZE}
          height={AVATAR_SIZE}
          className={`w-[${AVATAR_SIZE}px] h-[${AVATAR_SIZE}px] ${effects.borderRadius.full} object-cover`}
          referrerPolicy="no-referrer"
        />
        <div className="min-w-0 text-left">
          <div className={`${typography.size.sm} ${typography.weight.medium} ${colors.text.primary} truncate`}>
            {user?.displayName}
          </div>
          <div className={`${typography.size.xs} text-dark-text-muted`}>
            {planName} ({tokenCount})
          </div>
        </div>
      </div>
    </button>
  );
}
